import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  cancel(event) {
    event.preventDefault();
    const frame = this.element.closest("turbo-frame");
    if (!frame) return;

    const link = document.createElement("a");
    link.href = frame.dataset.originalUrl;
    link.className = "craig-report-link";
    link.setAttribute("data-turbo-frame", frame.id);
    link.textContent = "Report an issue";

    frame.innerHTML = "";
    frame.appendChild(link);
  }
}
